import { map } from 'rxjs/operators';
import { Category } from '../../shared/models/category.model';
import { MappedCollectionResponse } from '../models/mapped-collection-response.model';
import { ResponseNode } from '../models/response-node.model';

export const createCategoryObjects = map((response: MappedCollectionResponse): Array<Category> => (
  response.data.map((element: ResponseNode): Category => new Category().deserialize(element, response.dataMap))
));
